import { Component, OnDestroy, OnInit } from '@angular/core';
import { TabViewCustom } from '../../_models/tab-view-custom';
import { FuncionalidadesService } from '../../_services/funcionalidades.service';
import { forkJoin, Subscription } from 'rxjs';
import { FlujoVentaPasoService } from '../../_services/flujo-venta-paso.service';
import { NavService } from '../../_services/_nav.service';
import { FlujoVentaPaso } from '../../_models/flujo-venta-paso';
import { FuncionalidadControl } from '../../_models/funcionalidad-control';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ComunicationComponentsService } from '../../_services/comunication-components.service';
import { UtilitiesService } from '../../utils/utilities.service';
import { Pasos } from '../../_enums/enum';
import { ListaService } from '../../_services/lista.service';
import { ListaItem } from '../../_models/lista-item';
import { Plantilla } from '../../_models/plantilla';
import { PlantillaService } from '../../_services/plantilla.service';
import { EstadoService } from '../../_services/estado.service';

@Component( {
  selector: 'app-flujo-venta',
  templateUrl: 'flujo-venta.component.html',
  styleUrls: [ 'flujo-venta.component.scss' ]
} )

export class FlujoVentaComponent implements OnInit, OnDestroy {

  opcionesSort: any;
  listadoKey: string[] = [];
  cargando = true;
  pasos = {} as any;
  keySeleccionada: string;
  actSecuencia: boolean;
  maxSecuencia: number;
  destruirTab = false;
  listadoSecuencia: SelectItem[] = [];
  listadoSecuenciaCreacion: SelectItem[] = [];
  listadoFlujoVenta: FlujoVentaPaso[] = [];
  pasosEnum = Pasos;
  subscripcion: Subscription;
  itemModificado: string[] = [];
  lisVinculacion: SelectItem[] = [];
  listasTiposOcupaciones: SelectItem[] = [];
  lisAutorizaciones: ListaItem[] = [];
  lisFases: ListaItem[] = [];
  lisPlantillas: Plantilla[] = [];
  lisEstados: SelectItem[] = [];
  lisIntegraciones: SelectItem[] = [];
  listasTiposProductosBancarios: SelectItem[] = [];
  listasTiposPersonas: SelectItem[] = [];
  constructor( private funControlService: FuncionalidadesService,
               private navService: NavService,
               private conService: ConfirmationService,
               private utilitiesService: UtilitiesService,
               private comunicationComponentsService: ComunicationComponentsService,
               private lisService: ListaService,
               private plaService: PlantillaService,
               private estService: EstadoService,
               private fluVentaPasosService: FlujoVentaPasoService ) {
  }

  ngOnInit(): void {
    this.llenarPasos();
    this.cargarOpcionesSort();
    forkJoin( this.funControlService.obtenerFuncionalidadesControlesPorCodigoFuncionalidad( 'VENTAS' ),
      this.fluVentaPasosService.listado(),
      this.lisService.getMasterDetails( 'ListasTiposVinculaciones' ),
      this.lisService.getMasterDetails( 'ListasAutorizaciones' ),
      this.lisService.getMasterDetails( 'ListasFases' ),
      this.plaService.getAllEnabled(),
      this.estService.listadoHabilitados(),
      this.lisService.getMasterDetails('ListasIntegraciones'),
      this.lisService.getMasterDetails('ListasTiposProductosBancarios'),
      this.lisService.getMasterDetails( 'ListasTiposPersonas' ),
      this.lisService.getMasterDetails('ListasTiposOcupaciones')).subscribe( ( [ funcionalidades, flujoVenta, lisTiposVinculaciones, lisAutorizaciones, lisFases, lisPlantillas, lisEstados, lisIntegraciones, listasTiposProductosBancarios, listasTiposPersonas, listasTiposOcupaciones ] ) => {
      this.listadoFlujoVenta = flujoVenta;
      this.lisVinculacion = lisTiposVinculaciones.map( s => ( { label: s.nombre, value: s.idLista } ) );
      this.listasTiposOcupaciones = listasTiposOcupaciones.map( s => ( { label: s.nombre, value: s.idLista } ) );
      this.lisAutorizaciones = lisAutorizaciones;
      this.lisFases = lisFases;
      this.lisPlantillas = lisPlantillas;
      this.lisEstados = lisEstados.map( e => ( { label: e.nombre, value: e.idEstado } ) );
      this.listasTiposProductosBancarios = listasTiposProductosBancarios.map(e => ({label: e.nombre, value: e.idLista}));
      this.lisIntegraciones = lisIntegraciones as any;
      this.listasTiposPersonas = listasTiposPersonas.map( s => ( { label: s.nombre, value: s.idLista } ) );
      this.cargarTabs( flujoVenta, funcionalidades );
      this.escucharCanal();
      this.cargando = false;
    } );
  }

  llenarPasos() {
    this.pasos[ Pasos.DATOSBASICOS ] = {
      active: true, disabled: true, keyNombre: 'LBL_DATOBASICO', secuencia: 1, objeto: null, seccion: null
    };
    this.pasos[ Pasos.VALIDACIONIDENTIDAD ] = {
      active: false, disabled: false, keyNombre: 'LBL_VALIDACIONIDENTIDAD', secuencia: 2, objeto: null, seccion: null
    };
    this.pasos[ Pasos.CONSULTAS ] = {
      active: false, disabled: false, keyNombre: 'LBL_CONSULTAS', secuencia: 3, objeto: null, seccion: null
    };
    this.pasos[ Pasos.AUTORIZACIONES ] = {
      active: false, disabled: false, keyNombre: 'LBL_AUTORIZACIONES', secuencia: 4, objeto: null, seccion: null
    };
    this.pasos[ Pasos.COMPLEMENTARIOS ] = {
      active: false, disabled: false, keyNombre: 'LBL_COMPLEMENTARIOS', secuencia: 5, objeto: null, seccion: Pasos.DATOSBASICOS
    };
    this.pasos[ Pasos.SEGMENTOS ] = {
      active: false, disabled: false, keyNombre: 'LBL_SEGMENTO', secuencia: 6, objeto: null, seccion: null
    };
    this.pasos[ Pasos.HISTORIALCREDITO ] = {
      active: false, disabled: false, keyNombre: 'LBL_HISTORIALCREDITO', secuencia: 7, objeto: null, seccion: null
    };
    this.pasos[ Pasos.UNIDADCREDITO ] = {
      active: false, disabled: false, keyNombre: 'LBL_UNIDADCREDITO', secuencia: 8, objeto: null, seccion: null
    };
    this.pasos[ Pasos.OFERTA ] = {
      active: false, disabled: false, keyNombre: 'LBL_OFERTA', secuencia: 9, objeto: null, seccion: null
    };
    this.pasos[ Pasos.REFERENCIA ] = {
      active: false, disabled: false, keyNombre: 'LBL_REFERENCIAS', secuencia: 10, objeto: null, seccion: null
    };
    this.pasos[ Pasos.REQUISITO ] = {
      active: false, disabled: false, keyNombre: 'LBL_REQUISITOS', secuencia: 11, objeto: null, seccion: null
    };
    this.pasos[ Pasos.UNIDADPRODUCTIVA ] = {
      active: false, disabled: false, keyNombre: 'LBL_UNIDADPRODUCTIVA', secuencia: 12, objeto: null, seccion: null
    };
    this.pasos[ Pasos.UNIDADFAMILIAR ] = {
      active: false, disabled: false, keyNombre: 'LBL_UNIDADFAMILIAR', secuencia: 13, objeto: null, seccion: null
    };
    this.pasos[ Pasos.HOJAEVALUACION ] = {
      active: false, disabled: false, keyNombre: 'LBL_HOJAEVALUACION', secuencia: 14, objeto: null, seccion: null
    };
    this.pasos[ Pasos.RESPALDOS ] = {
      active: false, disabled: false, keyNombre: 'LBL_RESPALDOS', secuencia: 15, objeto: null, seccion: null
    };
    this.pasos[ Pasos.ADJUNTOS ] = {
      active: false, disabled: false, keyNombre: 'LBL_LISTADJUNTOS', secuencia: 16, objeto: null, seccion: null
    };
    this.pasos[ Pasos.POLITICA ] = {
      active: false, disabled: false, keyNombre: 'LBL_POLITICAS', secuencia: 17, objeto: null, seccion: null
    };
    this.pasos[ Pasos.SEGURO ] = {
      active: false, disabled: false, keyNombre: 'LBL_SEGURO', secuencia: 18, objeto: null, seccion: null
    };
    this.pasos[ Pasos.MONETIZACION ] = {
      active: false, disabled: false, keyNombre: 'LBL_MONETIZACION', secuencia: 19, objeto: null, seccion: null
    };
    this.pasos[ Pasos.COMITECREDITO ] = {
      active: false, disabled: false, keyNombre: 'LBL_COMITECREDITO', secuencia: 20, objeto: null, seccion: null
    };
    this.pasos[ Pasos.TARIFAS ] = {
      active: false, disabled: false, keyNombre: 'LBL_RECAUDO', secuencia: 21, objeto: null, seccion: null
    };
    this.pasos[ Pasos.CONTRATO ] = {
      active: false, disabled: false, keyNombre: 'LBL_CONTRATO', secuencia: 22, objeto: null, seccion: null
    };
    this.pasos[ Pasos.FINPROCESO ] = {
      active: false, disabled: true, keyNombre: 'LBL_FINPROCESO', secuencia: 23, objeto: null, seccion: null
    };
  }

  escucharCanal() {
    this.subscripcion = this.comunicationComponentsService.emisorComponent$.subscribe( r => {
      if ( r.canal === 'flujo-venta-actualizo' ) {
        this.actualizarHijos( r.mensaje );
      }

      if ( r.canal === 'flujo-venta-cargando' ) {
        this.actSecuencia = r.mensaje;
      }

    } );
  }

  cargarOpcionesSort() {
    this.opcionesSort = {
      onUpdate: async( event: any ) => {
        const validar = this.fluVentaPasosService.validarMovimiento( event.newIndex + 1, event.oldIndex + 1, this.listadoFlujoVenta, this.listadoKey[ event.newIndex ] );
        if ( validar.estado ) {
          this.actSecuencia = true;
          this.itemModificado = [];
          await this.actualizarSecuencia( event.newIndex, event.oldIndex, true, this.listadoKey[ event.newIndex ] );
          this.emitir(this.itemModificado);
          this.actSecuencia = false;
        } else {
          this.destruirTab = true;
          this.ordernarListado();
          this.conService.confirm( {
            message: validar.mensaje,
            header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
            key: 'flujo-venta',
            icon: 'fa fa-question-circle',
            accept: () => {
              this.destruirTab = false;
            }, reject: () => {
              this.destruirTab = false;
            }
          } );
        }
      },
      onMove: ( event: any ) => {
        if ( event.related.className.indexOf( 'item-sinmovimiento' ) !== -1 ) {
          return false;
        }
      }
    };
  }

  emitir(mensaje: string[]) {
    this.comunicationComponentsService.emitir( { canal: 'flujo-venta', mensaje: mensaje } );
  }

  cargarTabs( flujoVenta: FlujoVentaPaso[], funcionalidadControl: FuncionalidadControl[] ) {
    this.listadoKey = Object.keys( this.pasos );
    this.listadoKey.forEach( e => {
      const item = new TabViewCustom();
      item.codigo = e;
      item.flujoVenta = flujoVenta.find( x => x.codigo === e );
      item.disabled = this.pasos[ e ].disabled ? true : !item.flujoVenta;
      item.active = this.pasos[ e ].active;
      item.nombre = this.navService.buscarMensaje( `FLUJOVENTA.${ this.pasos[ e ].keyNombre }` );
      item.secuencia = item.flujoVenta ? item.flujoVenta.secuencia : this.pasos[ e ].secuencia;
      const codSeccion = this.pasos[ e ].seccion ? this.pasos[ e ].seccion : e;
      item.seccion = funcionalidadControl.find( x => x.codigo === codSeccion && x.indicadorSeccion );
      if ( item.seccion ) {
        item.controles = funcionalidadControl.filter( x => x.idPadre === item.seccion.idFuncionalidadControl );
      }
      this.pasos[ e ].objeto = item;
    } );
    this.ordernarListado();
    this.calcularMaximo();
    this.cargarSecuencias();
    this.keySeleccionada = this.listadoKey[ 0 ];
  }

  calcularMaximo() {
    this.maxSecuencia = this.listadoKey.filter( x => !this.pasos[ x ].objeto.disabled ).length + 2;
  }

  cargarListadoFlujoVenta() {
    this.listadoFlujoVenta = [];
    this.listadoKey.forEach( e => {
      if ( this.pasos[ e ].objeto.flujoVenta ) {
        this.listadoFlujoVenta.push( this.pasos[ e ].objeto.flujoVenta );
      }
    } );
  }

  ordernarListado() {
    this.listadoKey.sort( ( a, b ) => {
      return ( this.pasos[ a ].objeto.flujoVenta && this.pasos[ b ].objeto.flujoVenta ) ? ( this.pasos[ a ].objeto.secuencia - this.pasos[ b ].objeto.secuencia ) : ( ( this.pasos[ a ].objeto.secuencia !== 1 && this.pasos[ a ].objeto.secuencia !== 16 && this.pasos[ b ].objeto.secuencia !== 1 && this.pasos[ b ].objeto.secuencia !== 16 ) ? ( this.pasos[ a ].objeto.disabled ? 1 : -1 ) : ( this.pasos[ a ].objeto.secuencia - this.pasos[ b ].objeto.secuencia ) );
    } );
  }

  seleccionar( event: any, index: number ) {
    const item = this.listadoKey.find( x => this.pasos[ x ].objeto.active );
    if ( item ) {
      this.pasos[ item ].objeto.active = false;
    }
    this.pasos[ this.listadoKey[ index ] ].objeto.active = true;
    this.keySeleccionada = this.listadoKey[ index ];
  }

  async actualizarSecuencia( nueIndice: number, antIndice: number, actualizar: boolean, codigo: string ) {
    const listado = await this.fluVentaPasosService.listado().toPromise();
    const registros = [];
    const item = listado.find( x => x.codigo === codigo );
    if ( nueIndice !== antIndice ) {
      let inferior = null;
      let superior = null;
      let incremento = 1;
      if ( nueIndice > antIndice ) {
        inferior = antIndice + 1;
        superior = nueIndice;
        incremento = -1;
      } else {
        inferior = nueIndice;
        superior = antIndice - 1;
      }
      for ( let i = inferior; i <= superior; i++ ) {
        const buscar = listado.find( x => x.codigo === this.listadoKey[ actualizar ? ( i + incremento ) : i ] );
        if ( buscar ) {
          buscar.secuencia += incremento;
          this.itemModificado.push( buscar.codigo );
          registros.push( buscar );
        }
      }
      if ( actualizar ) {
        item.secuencia = nueIndice + 1;
        this.itemModificado.push( item.codigo );
        registros.push( item );
      }
    }

    if ( !!this.pasos[ Pasos.FINPROCESO ].objeto.flujoVenta && codigo !== Pasos.FINPROCESO ) {
      const regFinal = listado.find( x => x.codigo === Pasos.FINPROCESO );
      if ( regFinal && regFinal.secuencia !== listado.length) {
        regFinal.secuencia = listado.length;
        await this.fluVentaPasosService.actualizar( regFinal ).toPromise();
        this.pasos[ regFinal.codigo ].objeto.secuencia = regFinal.secuencia;
        this.pasos[ regFinal.codigo ].objeto.flujoVenta.secuencia = regFinal.secuencia;
        this.emitir([regFinal.codigo]);
      }
    }

    if ( registros.length > 0 ) {
      const actu = await this.fluVentaPasosService.bulk( registros ).toPromise();
      if ( !actualizar ) {
        actu.push( item );
      }
      this.actualizarObjetoPaso( actu );
    } else if ( !actualizar && !this.pasos[ codigo ].objeto.flujoVenta ) {
      this.pasos[ codigo ].objeto.secuencia = item.secuencia;
      this.pasos[ codigo ].objeto.flujoVenta = item;
      this.pasos[ codigo ].objeto.disabled = this.pasos[ codigo ].disabled ? true : false;
      this.cargarListadoFlujoVenta();
    } else if ( !actualizar ) {
      this.pasos[ codigo ].objeto.secuencia = item.secuencia;
      this.pasos[ codigo ].objeto.flujoVenta.secuencia = item.secuencia;
      this.pasos[ codigo ].objeto.disabled = this.pasos[ codigo ].disabled ? true : false;
      this.cargarListadoFlujoVenta();
    }
    return true;
  }

  actualizarObjetoPaso( listado: FlujoVentaPaso[] ) {
    listado.forEach( e => {
      this.pasos[ e.codigo ].objeto.disabled = this.pasos[ e.codigo ].disabled ? true : false;
      this.pasos[ e.codigo ].objeto.secuencia = e.secuencia;
      if ( this.pasos[ e.codigo ].objeto.flujoVenta ) {
        this.pasos[ e.codigo ].objeto.flujoVenta.secuencia = e.secuencia;
      } else {
        this.pasos[ e.codigo ].objeto.flujoVenta = e;
      }
    } );
    this.cargarListadoFlujoVenta();
  }


  async actualizarHijos( mensaje: any ) {
    this.actSecuencia = true;
    this.destruirTab = true;
    this.itemModificado = [];
    if ( mensaje.actualizar ) {
      await this.actualizarSecuencia( mensaje.nuevoIndice - 1, mensaje.antiguoIndice - 1, false, mensaje.codigo );
    } else {
      await this.actualizarSecuencia( mensaje.nuevoIndice - 1, this.maxSecuencia - 1, false, mensaje.codigo );
    }
    this.ordernarListado();
    this.calcularMaximo();
    this.cargarSecuencias();
    this.emitir(this.itemModificado);
    this.destruirTab = false;
    this.actSecuencia = false;
  }

  cargarSecuencias() {
    this.listadoSecuencia = [];
    this.listadoSecuenciaCreacion = [];
    this.utilitiesService.secuenciaTabsFlujoVenta.forEach( e => {
      if ( e.value < this.maxSecuencia ) {
        this.listadoSecuencia.push( e );
        this.listadoSecuenciaCreacion.push( e );
      } else if ( e.value === this.maxSecuencia ) {
        this.listadoSecuenciaCreacion.push( e );
      }
    } );
  }

  ngOnDestroy(): void {
    if ( this.subscripcion ) {
      this.subscripcion.unsubscribe();
    }
  }

}
